// JsFromRoutes CacheKey 3533ba25aa68b9d15d7a9af24504747a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/share-your-info/:token'),
  update: /* #__PURE__ */ definePathHelper('patch', '/share-your-info/:token'),
  optOut: /* #__PURE__ */ definePathHelper('get', '/share-your-info/:token/opt-out'),
  preferences: /* #__PURE__ */ definePathHelper('get', '/share-your-info/:token/preferences'),
  updatePreferences: /* #__PURE__ */ definePathHelper('patch', '/share-your-info/:token/preferences'),
}
